import { Add } from "@mui/icons-material";
import { Box, Button, Toolbar, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Table from "../../components/GrapeList/GrapeListTable";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { getCurrentUser } from "../../store/authentication/service";

const useStyles = makeStyles()((theme) => ({
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
}));

export const GrapeList = ({ searchText }) => {
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const { classes } = useStyles();
	const navigate = useNavigate();
	const [value, setValue] = useState("1");
	const user = getCurrentUser();
	return (
		<Box p={2}>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap>
					Grape / Stylist List
				</Typography>
				<Button
					onClick={() => {
						if (user?.user_type === 4) {
							navigate("/upload-playoff/grapelist/add");
						} else {
							navigate("/w86zjruk6q/grapelist/add");
						}
					}}
					startIcon={<Add />}
					variant="contained"
					color="primary"
				>
					Add List
				</Button>
			</Toolbar>

			<Box sx={{ px: 5 }}>
				<TabContext value={value}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<TabList
							onChange={handleChange}
							aria-label="lab API tabs example"
						>
							<Tab label="Grape List" value="1" />
							<Tab label="Stylist List" value="2" />
						</TabList>
					</Box>
					<TabPanel value="1">
						<Table list_type={"grape_list"} />
					</TabPanel>
					<TabPanel value="2">
						<Table list_type={"style_list"} />
					</TabPanel>
				</TabContext>

				{/* <Table /> */}
			</Box>
		</Box>
	);
};
